import * as Oidc from "oidc-client-ts";
import { UserManager, UserManagerSettings } from "oidc-client-ts";

export default class OidcManager {
    public user: Oidc.User | undefined;
    private mgr: UserManager;

    constructor(options: UserManagerSettings) {

        this.mgr = new UserManager({ ...options });

        this.mgr.events.addUserLoaded(user => {
            this.user = user;
        });
    }

    public authorize(): Promise<void> {
        return this.mgr.getUser().then(user => {
            if (user && !user.expired) {
                this.user = user;
                return;
            }
            if (user && user.refresh_token) {
                return this.mgr.signinSilent().then(renewed => {
                    if (renewed) {
                        this.user = renewed;
                        return;
                    }
                    return this.mgr.signinRedirect();
                }).catch(() => this.mgr.signinRedirect());
            }
            return this.mgr.signinRedirect();
        });
    }

    public signinRedirectCallback(): Promise<Oidc.User> {
        return this.mgr.signinRedirectCallback().then(user => {
            this.user = user;
            return user;
        });
    }

    public logout(): Promise<void> {
        return this.mgr.getUser().then(user => {
            if (!user || !user.id_token) {
                return this.mgr.signoutRedirect();
            }

            user.id_token = undefined;
            return this.mgr.storeUser(user).then(() => this.mgr.signoutRedirect());
        });
    }
    public async check(): Promise<void> {
        try {
            const user = await this.mgr.getUser();

            if (!user) {
                await this.mgr.signinRedirect();
                throw new Error("Redirected to signin");
            } else {
                this.user = user;
            }
        } catch (error) {
            throw error;
        }
    }
}


// WEBPACK FOOTER //
// ./ClientApp/services/api/oidcManager.ts